/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_RetryInputs */

const en_us2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const pt_br2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar de novo`)
};

const es_419_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const pt_pt2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar outra vez`)
};

const fr_fr2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_de2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const it_it2_history_transfer_retry = /** @type {(inputs: History_Transfer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {History_Transfer_RetryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_retry = /** @type {((inputs?: History_Transfer_RetryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_RetryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_retry(inputs)
	if (locale === "es-419") return es_419_history_transfer_retry(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_retry(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_retry(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_retry(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_retry(inputs)
	return en_us2_history_transfer_retry(inputs)
});
export { history_transfer_retry as "history-transfer.retry" }